<app-modal-window [title]="'Создание паркоместа'"
                  [visible]="true"
                  [width]="825"
                  [height]="638"
                  [scrollbar]="true"
                  (close)="dialogRef.close()">

  <form class="container" [formGroup]="form" (ngSubmit)="save()">
    <div class="container-body">
      <div class="form-control">
        <label>
          Тип паркинга <span class="required">*</span>
        </label>
        <div class="input-container">
          <div>{{ roomTypeItemTitle?.value }}</div>
        </div>
      </div>
      <div class="form-control">
        <label>
          Номер паркоместа <span class="required">*</span>
        </label>
        <div class="input-container">
          <input type="text" formControlName="placeNumber" class="input">
        </div>
      </div>
      <div class="form-control">
        <label>
          Общая площадь <span class="required">*</span>
        </label>
        <div class="input-container">
          <input type="text" formControlName="area" class="input" [mask]="'separator.2'">
          кв.м.
        </div>
      </div>
    </div>
    <div class="container-footer">
      <button class="btn" *ngIf="loadingSave; else loadedSave">
        <span class="loading"></span>
      </button>
      <ng-template #loadedSave>
        <button class="btn btn-apply" type="submit">Сохранить</button>
      </ng-template>
      <button class="btn btn-cancel" type="button" mat-dialog-close>Закрыть</button>
    </div>
  </form>

</app-modal-window>
